import React from 'react';
import {Link} from 'react-router-dom';

import { popularFooterPriceLinks } from '../SEO/config/seoPriceLinks';
import { popularFooterCalculatorLinks } from '../SEO/config/calculatorPages';

function Footer(){
  return (
    <div>
      <div className="row justify-content-center align-items-center mt-4">
        <div className="col-12 text-center justify-content-center align-items-center">
          <div className="footer-price-links">
            <div className="footer-price-links-title">Popular Price APIs</div>
            <div className="footer-price-links-list">
              {popularFooterPriceLinks.map((link) => (
                <Link key={link.to} to={link.to}>{link.label}</Link>
              ))}
            </div>
            <div className="footer-price-links-title footer-calculator-links-title">Popular Calculators</div>
            <div className="footer-price-links-list">
              {popularFooterCalculatorLinks.map((link) => (
                <Link key={link.to} to={link.to}>{link.label}</Link>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center align-items-center mt-4">
        <div className="col-12 text-center justify-content-center align-items-center">
          <span className="small text-muted">
            <span className="small">
              <Link to="/">Home</Link>
              &nbsp;•&nbsp;
              <Link to="/blog">Integration Guides</Link>
              &nbsp;•&nbsp;
              <a target="_blank" href="/blog/terms-of-service">Terms of Service</a>
              &nbsp;•&nbsp;
              <a target="_blank" href="/blog/privacy-policy">Privacy</a>
              &nbsp;•&nbsp;
              <a href="/llms.txt">llms.txt</a>
              &nbsp;•&nbsp;
              <a href="/openapi.json">API Specification</a>
              &nbsp;•&nbsp;
              <Link to="/api-documentation">API Documentation</Link>
              &nbsp;•&nbsp;
              <Link to="/mcp">MCP Server</Link>
              &nbsp;•&nbsp;
              <a target="_blank" rel="noopener noreferrer" href="https://github.com/orgs/goldapi-io/repositories">GitHub Repositories</a>
              &nbsp;•&nbsp;
              <a href="mailto:support@goldapi.io">Contacts</a>
            </span>
          </span>
        </div>
      </div>
      <div className="row justify-content-center align-items-center">
        <div className="col-12 text-center justify-content-center align-items-center">
          <span className="small text-muted">
            <span className="small">
            GoldAPI is a Free Gold Prices API and Silver Prices RESTful JSON API. 100% Real-Time Live Feed of Precious Metals Spot Prices.
            </span>
          </span>
        </div>
      </div>
      <div className="row justify-content-center align-items-center mb-5">
        <div className="col-12 text-center justify-content-center align-items-center">
          <span className="small text-muted">
            <span className="small">
              © 2020-2026, GoldAPI.io
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
